var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activationFlag === 0)?_c('div',{staticClass:"auth-ambassador"},[(_vm.$utils.isPhone())?_c('sub-h5-auth-ambassador'):_c('popup-login-process',{attrs:{"authAmbassadorObj":_vm.authAmbassadorObj}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }